import React, { useEffect, useState } from 'react';
import ProductCard from './ProductCard';
import { Product } from '../types';
import { getApiUrl } from '../config';
import styles from './ProductList.module.css';

const ProductList: React.FC = () => {
  const [products, setProducts] = useState<Product[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        console.log('Fetching products...');
        const response = await fetch(`${getApiUrl('/api/products')}`, {
          headers: {
            Accept: 'application/json',
          },
          mode: 'cors',
        });
        console.log('Response received:', response.status);
        if (!response.ok) {
          throw new Error(`Failed to fetch products: ${response.status} ${response.statusText}`);
        }
        const data = await response.json();
        console.log('Products fetched:', data);
        setProducts(data);
      } catch (err) {
        console.error('Error fetching products:', err);
        setError(err instanceof Error ? err.message : 'Failed to fetch products');
      } finally {
        setLoading(false);
      }
    };

    console.log('ProductList component mounted');
    fetchProducts();
  }, []);

  if (loading) {
    return <div className={styles.loadingContainer}>Loading products...</div>;
  }

  if (error) {
    return <div className={styles.errorContainer}>{error}</div>;
  }

  return (
    <div className={styles.productList}>
      {products?.length === 0 ? (
        <div className={styles.noProductsMessage}>No products available.</div>
      ) : (
        products.map((product) => <ProductCard key={product.id} product={product} />)
      )}
    </div>
  );
};

export default ProductList;
